import React from "react";
import { Link, useLocation  } from "react-router-dom";


const Navbar = () => {
  const location = useLocation();
  const current = location.pathname;
return(
    <>
        <div className="container-fluid bg-white sticky-top wow fadeIn" data-wow-delay="0.1s">
        <div className="container">
            <nav className="navbar navbar-expand-lg bg-white navbar-light p-lg-0">
                <a href="index.html" className="navbar-brand d-lg-none">
                    <h1 className="fw-bold m-0">SMN</h1>
                </a>
                <button type="button" className="navbar-toggler me-0" data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav">
                        <Link to="/" className={`nav-item nav-link ${current === "/" ? "active" : ""}`}>Home</Link>
                        <Link to="/about" className={`nav-item nav-link ${current === "/about" ? "active" : ""}`}>About</Link>
                      
                        <div className="nav-item dropdown">
                            <Link to="/expertise" className={`nav-link dropdown-toggle nav-item  ${current === "/expertise" ? "active" : ""}`} data-bs-toggle="dropdown">Expertise</Link>
                            <div className="dropdown-menu bg-light rounded-0 rounded-bottom m-0">
                                <Link to="/expertise#tax" className="dropdown-item">Tax Matters</Link>
                                <Link to="/expertise#financial" className="dropdown-item">Financial Services</Link>
                                <Link to="/expertise#corporate" className="dropdown-item">Corporate Services</Link>
                                <Link to="/expertise#property" className="dropdown-item">Property Services</Link>
                                <Link to="/expertise#banking" className="dropdown-item">Banking & Finance</Link>
                                <Link to="/expertise#commercial" className="dropdown-item">Commercial Services</Link>
                                <Link to="/expertise#water" className="dropdown-item">Water & Power</Link>
                                <Link to="/expertise#realestate" className="dropdown-item">Real Estate</Link>
                                <Link to="/expertise#dispute" className="dropdown-item">Dispute Resolution</Link>
                                <Link to="/expertise" className="dropdown-item">View All</Link>
                            </div>
                        </div>

                        <div className="nav-item dropdown">
                            <a href="#" className={`nav-link dropdown-toggle nav-item  ${current === "/team" ? "active" : ""}`} data-bs-toggle="dropdown">Team</a>
                            <div className="dropdown-menu bg-light rounded-0 rounded-bottom m-0">
                                <Link to="/team#SMurtaza" className="dropdown-item">Sahibzada Murtaza Ali</Link>
                                <Link to="/team#GMujtaba" className="dropdown-item">Ghulam Mujtaba Ilyas</Link>
                                <Link to="/team#SZain" className="dropdown-item">Syed Zain Raza Naqvi</Link>
                                <Link to="/team#associates" className="dropdown-item">Associates</Link>
                                <Link to="/team" className="dropdown-item">View All</Link>
                            </div>
                        </div>

                        <Link to="/portfolio" className={`nav-item nav-link ${current === "/portfolio" ? "active" : ""}`}>Portfolio</Link>
                        <Link to="/contact" className={`nav-item nav-link ${current === "/contact" ? "active" : ""}`}>Contact</Link>
                    </div>
                    <div className="ms-auto d-none d-lg-block">
                        <Link to="/contact" className="btn btn-primary py-2 px-3">Click to Schedule a Meeting</Link>
                    </div>
                </div>
            </nav>
        </div>
    </div>
    </>
)
}


export default Navbar;